<form [formGroup]="form" autocomplete="off">
  <div *ngIf="fresnelColor || fresnelOpacity" class="text-dim text-12 pb-4">
    <span class="text-bold">Note:</span> The preset you have selected contains some settings that cannot be customized.
  </div>


  <!-- Tint -->
  <app-form-field label="Color" *ngIf="!fresnelColor">
    <input
      class="input"
      type="text"
      [colorPicker]="colorPickerHex" 
      (colorPickerChange)="handleColorPickerChange($event)" 
      [cpOutputFormat]="'hex'"
      [cpAlphaChannel]="'disabled'"
      [style.background]="colorPickerHex" 
      cpPosition="left">
  </app-form-field>

  <!-- Saturation -->
  <app-form-field label="Saturation">
    <app-slider [min]="-100" [max]="100" formControlName="saturation"></app-slider>
  </app-form-field>

  <!-- Contrast -->
  <app-form-field label="Contrast">
    <app-slider [min]="-100" [max]="100" formControlName="contrast"></app-slider>
  </app-form-field>

  <!-- Brightness -->
  <app-form-field label="Brightness">
    <app-slider [min]="-100" [max]="100" formControlName="brightness"></app-slider>
  </app-form-field>

  <!-- Opacity -->
  <app-form-field label="Opacity" *ngIf="!fresnelOpacity">
    <app-slider [min]="0" [max]="100" formControlName="opacity"></app-slider>
  </app-form-field>
</form>